import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ArrowLeftIconProps = Omit<BaseIconProps, 'children'>;

export const ArrowLeftIcon = ({ strokeWidth, hasLegacyStrokeStyles, ...props }: ArrowLeftIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 18 15" fill="#141B4D" {...props}>
    <path d="M7.70711 2.20711C8.09763 1.81658 8.09763 1.18342 7.70711 0.792893C7.31658 0.402369 6.68342 0.402369 6.29289 0.792893L0.292893 6.79289C-0.0976311 7.18342 -0.0976311 7.81658 0.292893 8.20711L6.29289 14.2071C6.68342 14.5976 7.31658 14.5976 7.70711 14.2071C8.09763 13.8166 8.09763 13.1834 7.70711 12.7929L3.41421 8.5L17.0556 8.5C17.5772 8.5 18 8.05229 18 7.5C18 6.94772 17.5772 6.5 17.0556 6.5L3.41421 6.5L7.70711 2.20711Z" />
  </BaseIcon>
);
